module.exports = __webpack_public_path__ + "img/red_031.cff58e85.png";